import FormatService from 'src/services/format.service';
import { DlsTypographyVariants } from 'src/types/dls-typography-variants.enum';
import React from 'react';
import { LocalDate } from '@js-joda/core';
import Selectors from 'src/utils/selectors';

interface Props {
    date: LocalDate;
    className?: string;
}

export default function TransactionDate({ date, className }: Props): JSX.Element {
    const transactionDate: string = FormatService.formatShortDateWithYear(date, true);

    return (
        <p className={className ?? DlsTypographyVariants.LABEL_1} data-cy={Selectors.Transactions.DATE_VALUE}>
            {transactionDate}
        </p>
    );
}
